import {  Component, Vue } from "vue-property-decorator"
import { getFinanceOrderStatisticalData, financeOrderStatisticalDataExport ,getDepartmentByLevel} from '@/api/financial-center'
import { delNullProperty } from '@/utils/index'
import { formatDate } from '@/utils/timeFilter'
import {UserModule} from "@/store/modules/user";
import {getDeparmentList} from "@/api/common";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData";

const projectTypeFilter = commonData.projectTypeArray

@Component({
  components:{
    MoreUsersFilter
  }
})
export default class OrderStatisticsData extends Vue {
  projectTypeFilter = projectTypeFilter //项目类型
  page = 1
  limit = 20
  total = 0
  dissertationType = ''
  createdAt = []
  souCourseName = ''
  attendSchool = ''
  specialized = ''
  grade = ''
  souCourseSchoolBegin = []
  tableData = []
  tableLoading = false
  // isReadonly = false

  exportButtonDisabled = false
  gradeList = [  // 年级列表
    '美制7年级/英制8年级/初一（普高）',
    '美制8年级/英制9年级/初二（普高）',
    '美制9年级/英制10年级/初三（普高）',
    '美制10年级/英制11年级/高一（普高）',
    '美制11年级/英制12年级/高二（普高）', '美制12年级/英制13年级/高三（普高）',
    '大学一年级',
    '大学二年级',
    '大学三年级',
    '大学四年级',
    '研究生及以上',
    '已毕业'
  ]
  customerName = ''
  customerEduCode = ''
  customerSource = ''
  financeOrderCode = ''
  caseStatus = ''
  directorUserId = ''
  souCourseTypeId = ''
  departmentIdList= []
  deparmentList: any = [] // 部门列表
  checkRangeDepartmentList: Array<number> = [] // 适用范围内选中的部门 id
  accessibleList: any = []
  checkDeparmentInfo: any = [] // 选中的部门信息
  timer = null
  types = ''
  adviser = ''
  filter_cooperSource = ''
  overseasStudy = '' // 是否留学
  departmentList = []
  level2DepartmentIdList = ''
  helperUserId = ''
  backMoneyStatus = []
  backMoneyType = ''

  created() {
    this.getTableData()
    this.getDeparment()
  }

  handleLevalPersonl(val) {
    this.getDepartmentByLevel(val)
  }

  // 等级人员列表
  async getDepartmentByLevel(level) {
    const data: any = await getDepartmentByLevel(level)
    this.departmentList = data.departmentList
  }

  async getDeparment() {
    const data: any = await getDeparmentList()
    this.deparmentList = data
  }

  chooseDepartment(checkedKeys,checkedData){

    // 取消勾选
    const [accessibleList,getCheckedKeys] = [this.accessibleList,(this.$refs.tree as HTMLFormElement).getCheckedKeys()];
    // 循环删除this.accessibleList中的项
    for(const i in accessibleList){
      if(accessibleList[i].id == checkedKeys.id){
        this.accessibleList.splice(i,1);
        return;
      }
    }
    // 添加勾选
    const [arr,newArr] = [[],(this.$refs.tree as HTMLFormElement).getCheckedKeys()];
    arr.push(checkedKeys);
    function dealData(arr,newArr){
      for(const i in arr){
        newArr.push(arr[i].id);
        dealData(arr[i].children,newArr);
      }
    }
    // newArr代表获取出来的当前节点以及其下的所有子节点的id
    dealData(arr,newArr);
    (this.$refs.tree as HTMLFormElement).setCheckedKeys(newArr);
    // newJsonArr代表所有选中的节点
    const newJsonArr = (this.$refs.tree as HTMLFormElement).getCheckedNodes();
    this.accessibleList = newJsonArr;
    this.checkDeparmentInfo = []

    newJsonArr.map(item => {
      this.checkDeparmentInfo.push({
        department: {
          name: item.name,
          detail: null,
          id: item.id
        },
        departmentId: item.id
      })
    })

  }

  treeChange(item: any, itembol: boolean) {
    if(itembol) {
      const res = (this.$refs.tree as HTMLFormElement).getCheckedNodes()
      const arrDeptId = []
      res.forEach((item) => {
        arrDeptId.push({
          department: {
            name: item.name,
            detail: null,
            id: item.id
          },
          departmentId: item.id
        })
      })
      this.checkDeparmentInfo = arrDeptId
    } else {

      this.checkDeparmentInfo.map((t: any, i: number) => {
        if(t.departmentId === item.id){
          this.checkDeparmentInfo.splice(i, 1)
        }
      });
    }

    this.checkRangeDepartmentList = []
    this.checkDeparmentInfo.forEach((item) => {
      this.checkRangeDepartmentList.push(item.departmentId)
    })
    this.departmentIdList = this.checkRangeDepartmentList

  }

  async getTableData() {


    this.tableLoading = true

    const { allNum, financeOrderList } = await getFinanceOrderStatisticalData(delNullProperty({
      limit: this.limit,
      page: this.page,
      dissertationType: this.dissertationType,
      createdAt: this.createdAt && this.createdAt.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.createdAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.createdAt[1])) : '',
      souCourseName: this.souCourseName,
      souCourseSchoolBegin: this.souCourseSchoolBegin && this.souCourseSchoolBegin.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.souCourseSchoolBegin[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.souCourseSchoolBegin[1])) : '',
      school:this.attendSchool,
      grade:this.grade,
      specialized:this.specialized,
      customerName : this.customerName,
      customerEduCode : this.customerEduCode,
      customerSource : this.customerSource,
      financeOrderCode : this.financeOrderCode,
      caseStatus : this.caseStatus,
      directorUserId : this.directorUserId,
      souCourseTypeIdList : this.souCourseTypeId,
      departmentIdList: this.departmentIdList,
      types: this.types,
      marketCooperationSource: this.filter_cooperSource,
      overseasStudy: this.overseasStudy,
      level2DepartmentIdList: this.level2DepartmentIdList,
      helperUserId: this.helperUserId,
      backMoneyStatusList: this.backMoneyStatus,
      marketCooperationBackMoneyType: this.backMoneyType,
    })) as unknown as { allNum: number; financeOrderList: any[] }
    this.tableData = financeOrderList
    this.total = allNum
    this.tableLoading = false
    // this.isReadonly = false
  }

  // 导出
  async exportExcel() {
    this.exportButtonDisabled = true
    this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    financeOrderStatisticalDataExport(delNullProperty({
      dissertationType: this.dissertationType,
      createdAt: this.createdAt && this.createdAt.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.createdAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.createdAt[1])) : '',
      souCourseSchoolBegin: this.souCourseSchoolBegin && this.souCourseSchoolBegin.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.souCourseSchoolBegin[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.souCourseSchoolBegin[1])) : '',
      souCourseName: this.souCourseName,
      school:this.attendSchool,
      grade:this.grade,
      specialized:this.specialized,
      customerName : this.customerName,
      customerEduCode : this.customerEduCode,
      customerSource : this.customerSource,
      financeOrderCode : this.financeOrderCode,
      caseStatus : this.caseStatus,
      directorUserId : this.directorUserId,
      souCourseTypeIdList : this.souCourseTypeId,
      departmentIdList : this.departmentIdList,
      types: this.types,
      adviser: this.adviser,
      marketCooperationSource: this.filter_cooperSource,
      overseasStudy:this.overseasStudy,
      level2DepartmentIdList:this.level2DepartmentIdList,
      helperUserId:this.helperUserId,
      backMoneyStatusList:this.backMoneyStatus,
      marketCooperationBackMoneyType: this.backMoneyType,
    })).finally(() => {
      this.exportButtonDisabled = false
    })
  }

  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }

  changeHelperUserId(e) {
    this.helperUserId = e.id
    this.page = 1
    this.getTableData()
  }

  changeDirectorUserId(e) {
    this.directorUserId = e.id
    this.page = 1
    this.getTableData()
  }

}
